module.exports = __webpack_public_path__ + "img/right.f4b39030.png";